export enum ButtonCategory {
  STANDARD = 'standard',
  CUSTOM = 'custom'
}
